/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ChangedEvent } from '@typescript-kit/core';
import { FormFieldModel, ComponentModel, TextModel, ViewComponentKey } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';

@Component({
  selector: 'kit-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldComponent extends BaseDirective<FormFieldModel> {
  private _labelModel: ComponentModel;

  get hostClass(): string {
    return 'kit-form-field';
  }

  get labelModel(): ComponentModel {
    return this._labelModel;
  }

  protected onModelChanged(model: FormFieldModel) {
    super.onModelChanged(model);
    this.refreshLabel();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes['label'] || event.changes['control'] || event.changes['control.key'] || event.changes['control.scope']) {
      this.refreshLabel();
    }
  }

  protected refreshLabel() {
    if (typeof this.model.label === 'string') {
      this._labelModel = new TextModel({
        type: ViewComponentKey.LABEL,
        text: this.model.label
      });
    } else if (this.model.label === true && this.model.control) {
      const scope = this.model.control.scope;
      const key = this.model.control.key;
      this._labelModel = new TextModel({
        type: ViewComponentKey.LABEL,
        text: scope ? `${scope}/${key}` : key
      });
    } else if (this.model.label instanceof ComponentModel) {
      this._labelModel = this.model.label;
    } else {
      this._labelModel = null;
    }
  }

}
